var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main',{staticClass:"main-content"},[_c('h1',[_vm._v("The requested page not found")])])])
}]

export { render, staticRenderFns }